import { ro as reactro } from '@ews/react-translations';

const ro = {
...reactro
}
export default ro
